<div class="modal-header">
  <div class="title">
    <span class="header">Distributing JMEP keys...</span>
  </div>
  <div class="btn-group" (click)="close()">
    <i class="mdi mdi-close close-icon"></i>
  </div>
</div>

<div class="dialog-content">
  <table class="data-table">
    <!-- Table Headers for Name and Status -->
    <thead>
      <tr>
        <th>ESAM</th>
        <th>Status</th>
      </tr>
    </thead>
    <!-- Data Rows -->
    <tbody>
      <tr *ngFor="let item of data">
        <td class="left-align">{{ item.name }}</td>
        <td
          [ngClass]="{
            'complete-status': item.status === 'complete',
            'in-progress-status': item.status !== 'complete'
          }"
        >
          {{ item.status }}
        </td>
      </tr>
    </tbody>
  </table>
</div>

<div class="dialog-actions">
  <div class="btn-group">
    <button mat-button class="save-btn cancel" (click)="close()">Close</button>
  </div>
</div>
